import { connect } from 'react-redux';
import { getTranslation } from 'redux/modules/translation/selectors';
import store from 'redux/store';

interface rootReducer extends types.redux.rootReducer {}

interface TProps {
	translation: Function;
	children: string;
}

const T = ({ translation, children }: TProps) => {
	return translation(children);
};

const mapStateToProps = (state: rootReducer) => {
	return {
		translation: (key: string) => getTranslation(state, key),
	};
};

export const translate = (key: string, ...content: Array<string | number>): string => {
	const state = store.getState();
	let output = getTranslation(state, key);
	content.forEach((val) => {
		const index = output.indexOf('%%');
		if (!!~index) {
			const start = output.slice(0, index);
			const end = output.slice(index + 2);
			output = start + val + end;
		}
	});

	return output;
};

export const dynamicTranslate = (value: string, ...content: Array<string | number>): string => {
	content.forEach((val) => {
		const index = value.indexOf('%%');
		if (!!~index) {
			const start = value.slice(0, index);
			const end = value.slice(index + 2);
			value = start + val + end;
		}
	});

	return value;
};

export default connect(mapStateToProps)(T);
